import topicTemplate from "./topic.html";
import { SPANISH, ENGLISH } from "../../../../app.constants";
import {
    createCloudinaryPollUrl,
    getCloudinaryUrl,
} from "../../../../common/common/common.utils";
import { TEXT, SLIDES, VIDEO } from "../../../../common/safety/constants";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";

import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import mixpanel from "mixpanel-browser";
import { recommendClient } from "@algolia/recommend";

class TopicController {
    /* @ngInject */
    constructor($http, PublicTrainingService, $scope, ToastService) {
        this.SPANISH = SPANISH;
        this.ENGLISH = ENGLISH;
        this.TEXT = TEXT;
        this.SLIDES = SLIDES;
        this.VIDEO = VIDEO;
        this.$http = $http;
        this.LOGO_URL = logoUrl;
        this.PublicTrainingService = PublicTrainingService;
        this.$scope = $scope;
        this.ToastService = ToastService;
    }

    $onInit() {
        let ctrl = this;
        ctrl.translateds = _.orderBy(ctrl.topic.translations, ["language"]);
        if (ctrl.topic.category === ctrl.SLIDES) {
            for (let translated of ctrl.translateds) {
                if (translated.pdf_public_id) {
                    ctrl.$http
                        .head(createCloudinaryPollUrl(translated.pdf_public_id))
                        .then(
                            function (response) {},
                            function (response) {
                                if (response.status !== 400) {
                                    ctrl.ToastService.create(
                                        "publicSafetyMeetingTopic.SLIDES_UNAVAILABLE",
                                    );
                                    return;
                                }
                                let headers = response.headers();
                                let str = headers["x-cld-error"];
                                let max_page_number = str.match(/[0-9]+/);
                                let slides = [];
                                for (
                                    let page = 1;
                                    page <= max_page_number;
                                    page++
                                ) {
                                    let url = getCloudinaryUrl(
                                        "f_auto,pg_" +
                                            page +
                                            ",q_auto:eco/" +
                                            translated.pdf_public_id,
                                    );
                                    slides.push(url);
                                }
                                translated.slideUrls = slides;
                            },
                        );
                }
            }
        }

        // ctrl.PublicTrainingService.getAlgoliaKey().then(function (data) {
        //     recommendClient(process.env.ALGOLIA_APP_ID, data.public_key)
        //         .getRelatedProducts([
        //             {
        //                 indexName: "safety_topic_index",
        //                 objectID: ctrl.topic.sid,
        //             },
        //         ])
        //         .then(({ results }) => {
        //             ctrl.$scope.$applyAsync(function () {
        //                 ctrl.relatedTopics = _.slice(results[0].hits, 0, 3);
        //             });
        //         });
        // });
    }

    print() {
        let ctrl = this;
        mixpanel.track("Printed public topic", { topic_sid: ctrl.topic.sid });
        window.print();
    }
}
export default {
    bindings: { topic: "<", defaultTranslation: "<" },
    controller: TopicController,
    template: topicTemplate,
    name: "publicSafetyMeetingTopic",
    translations: { en, es },
};
